<div class="side_nav">
  <app-side-nav
    [sideNavItems]="sideNavItems()"
    [isExpanded]="isMenuExpanded() || false"
    [pinnedOpened]="isMenuExpanded() || false"
    [isLoading]="isLoading()"
    (pinnedToggled)="toggleSideNav()"
  />
</div>
